import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    userInfo: {}, //用户信息
    lang: {
      code: "代码",
    },
  },
  getters: {
    getLang(state) {
      return state.lang;
    },
  },
  mutations: {
    //用户信息
    changeUserInfo(state, value) {
      state.userInfo = value;
    },
  },
  actions: {},
  modules: {},
});
